
export function ConvertStr2DatetimeLocal(dateStr) {
  // convert datetime string with time zone to datetime string with time zone
  if (!dateStr) return "";

  const dateObj = new Date(dateStr);
  if (isNaN(dateObj.getTime())) return "";

  function ten(i) {
    // pandding "0" while digital is 0 ~ 9
    return (i < 10 ? "0" : "") + i;
  }  

  // those are get local time value
  const YYYY = dateObj.getFullYear();
  const MM = ten(dateObj.getMonth() + 1);
  const DD = ten(dateObj.getDate());
  const HH = ten(dateObj.getHours());
  const II = ten(dateObj.getMinutes());
  const SS = ten(dateObj.getSeconds());
  return YYYY + "-" + MM + "-" + DD + "T" + HH + ":" + II + ":" + SS;
}

// 將字串轉為 input[type="datetime-local"] 需要的格式（yyyy-MM-ddTHH:mm）
export function ConvertStr2DatetimeLocal2(dateStr) {
  if (!dateStr) return "";

  const date = new Date(dateStr);
  if (isNaN(date.getTime())) return "";

  // 考慮時區差異（把 UTC 轉成本地時間）
  const offset = date.getTimezoneOffset();
  const localDate = new Date(date.getTime() - offset * 60000);
  return localDate.toISOString().slice(0, 16);
}

// 將 datetime-local 的輸入值轉為 RFC3339 (ISO 8601)，傳給後端
export function toRFC3339(datetimeLocalStr) {
  if (!datetimeLocalStr) return "";

  const date = new Date(datetimeLocalStr);
  return !isNaN(date.getTime()) ? date.toISOString() : "";
}

export function ConvertStr2DateLocal(dateStr) {
  // convert datetime string with time zone to datetime string with time zone

  function ten(i) {
    // pandding "0" while digital is 0 ~ 9
    return (i < 10 ? "0" : "") + i;
  }

  const dateObj = new Date(dateStr);

  // those are get local time value
  const YYYY = dateObj.getFullYear();
  const MM = ten(dateObj.getMonth() + 1);
  const DD = ten(dateObj.getDate());

  return YYYY + "-" + MM + "-" + DD;
}